import(/* webpackMode: "eager" */ "/home/ubuntu/download/69944416f782d50014426ee5/mulumbuminerals/src/app/homepage/page.tsx");
